import { appointmentSlice } from "./slice";

export const { newAppointment, updateFilters,updateFiltersModal, clearStatus, setNewAppointmentID } = appointmentSlice.actions

export default appointmentSlice.reducer;
